export default "__VITE_ASSET__BO1QX_HN__";